import React, {useState} from 'react';
import classes from './Keyboard.module.css';
import {mdiBackspaceOutline} from '@mdi/js';
import Icon from '@mdi/react';

const Keyboard = props => {
    const [displayText, setDisplayText] = useState('');
    const dialing = event => {
        if (event.target.localName === 'li') {
            props.sendDtmf(event.target.innerText)
            let cutDisplayText = displayText.length < 10 ? displayText : displayText.slice(1)
            setDisplayText(cutDisplayText + event.target.innerText)
        }
    }

    return (
        <>
        <div className={`${classes.keyboard} ${props.isOpen ? classes.keyboardActive : ''}`}>
            <div className={classes.display}>
                {displayText}
                <Icon onClick={props.toggleKeyboard}
                      className={classes.buttonClose}
                      path={mdiBackspaceOutline}
                      size={1}
                />
            </div>
            <ul onClick={dialing}>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>0</li>
            </ul>
        </div>
        <div className={props.isOpen ? classes.backdrop : ''} onClick={props.toggleKeyboard}></div>
        </>
    );
};
export default Keyboard